import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import CheeseProduct from 'models/CheeseProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import Switch from 'react-switch'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  cheeseTypeOptions,
  fatLevelOptions,
  packagingInitialState,
} from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'

const CheesePackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSelect, setSwitch, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        FatLevel,
        Type,
        Size,
        MadeInUSA,
        Kosher,
      } = current
      setPackaging({
        category,
        subCategory,
        FatLevel: {
          value: FatLevel || '',
          label: FatLevel.length > 0 ? FatLevel : 'Select Fat Level',
        },
        Type: {
          value: Type || '',
          label: Type.length > 0 ? Type : 'Select Cheese Type',
        },
        Size,
        MadeInUSA: MadeInUSA ?? false,
        Kosher: Kosher ?? false,
      })
    } else if (!updating) {
      setCurrent(CheeseProduct)
      setPackaging(packagingInitialState)
    }
    console.log(current)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Fat Level {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={fatLevelOptions}
          name="FatLevel"
          control={methods.control}
          rules={{ required: true }}
          defaultValue={fatLevelOptions[0].value}
          placeholder={'Select Fat Level'}
          onChange={([selected]) => {
            setSelect(selected, 'FatLevel')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="FatLevel"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          name="Type"
          placeholder={'Select Cheese Type'}
          options={cheeseTypeOptions}
          onChange={([selected]) => {
            setSelect(selected, 'Type')
            return selected
          }}
          control={methods.control}
          rules={{ required: true }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="Type"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Input defaultValue={'16 ounces only'} disabled />
        </FormGroup>
      </Col>
      <Col xs={6}>
        <p>
          <strong>
            I verify that this product is made in the USA {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="MadeInUSA"
          id="MadeInUSA"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          checked={packaging.MadeInUSA}
          rules={{ validate: MadeInUSA => MadeInUSA === true }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="MadeInUSA"
            message={'⚠ Product must be made in the USA.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <hr />
        <p>
          <strong>Kosher</strong>
        </p>
        <Controller
          as={Switch}
          name="Kosher"
          id="Kosher"
          onChange={([checked]) => {
            setCurrent({ ...current, Kosher: checked })
            return checked
          }}
          control={methods.control}
          checked={packaging.Kosher}
        />
      </Col>
      <br />
    </Row>
  )
}

export default CheesePackage

export const getCheesePackage = newProduct => {
  const newCheesePackage = {
    UPC: newProduct.UPC,
    FatLevel: newProduct.FatLevel,
    Type: newProduct.Type,
    Size: newProduct.Size,
    MadeInUSA: newProduct.MadeInUSA,
    Kosher: newProduct.Kosher,
  }
  return newCheesePackage
}

export const updateCheesePackage = newProduct => {
  const newCheesePackage = {
    UPC: newProduct.UPC,
    FatLevel: newProduct.FatLevel,
    Type: newProduct.Type,
    Size: newProduct.Size,
    MadeInUSA: newProduct.MadeInUSA,
    Kosher: newProduct.Kosher,
  }
  return newCheesePackage
}
